import getField from '../getField'

// get the value of a statistic, if the value has units, the unit may be supplied, or the unit 'as entered' will be used
const getValueFromStatistic = (stat, unit) => {
	const val = getField(stat, 'value')
	return Number.isFinite(val) ? val : getField(val, unit || getField(stat, 'unit'))
}

export default getValueFromStatistic



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getValueFromStatistic.js